import { render, staticRenderFns } from "./TablaResultados.vue?vue&type=template&id=6f2a3215&scoped=true&"
import script from "./TablaResultados.vue?vue&type=script&lang=js&"
export * from "./TablaResultados.vue?vue&type=script&lang=js&"
import style0 from "./TablaResultados.vue?vue&type=style&index=0&id=6f2a3215&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a3215",
  null
  
)

export default component.exports